<div class="row">
  <div class="col-xs-12 col-12 col-md-4 form-group">
    <input type="text"
           placeholder="Datepicker"
           class="form-control"
           [bsConfig]="{ customTodayClass: 'custom-today-class' }"
           bsDatepicker>
  </div>
</div>
